import "../../../admin/css/react-select.css";

// alias to shared package
export {Select as default} from "@hosttools/frontend/components/Select";
export * from "@hosttools/frontend/components/Select";
